import { render } from "./AppointmentFormatBadge.vue?vue&type=template&id=22e204d0"
import script from "./AppointmentFormatBadge.vue?vue&type=script&lang=js"
export * from "./AppointmentFormatBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__